import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { LoginAttemptService } from '@core/authorization/services/login-attempt.service';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';

export const hasLoginContextGuard: CanMatchFn = () => {
  const loginAttemptService = inject(LoginAttemptService);
  const router = inject(Router);

  return loginAttemptService.isLoginAttemptSet.pipe(
    map(loginAttempt => {
      if (loginAttempt) {
        return true;
      }

      return router.createUrlTree([TopNavigationPath.Home]);
    })
  );
};
